import { MetricFormat } from "app/common/benchmark/types";
import {
    abbrNumberFilter,
    abbrNumberWithPrefixFilter,
    percentageSignFilter,
    simplePercentageFilter,
} from "app/filters/ngFilters";
import { numberFilter, pureNumberFilter } from "app/filters/numberFilter";

const TIME_FORMAT = "HH:mm:ss";

export const DEFAULT_DECIMAL = 2;
export const PERCENTAGE = "%";
export const PERCENTAGE_POINT = "pp";

export const FORMATTERS: Record<MetricFormat, (val: number, decimal?: number) => string> & {
    numberAbbrWithPrefix: (val: number | null, prefix: string) => string;
} = {
    [MetricFormat.number]: (val, decimal = DEFAULT_DECIMAL) => numberFilter()(val, decimal),
    [MetricFormat.numberAbbr]: (val, decimal = DEFAULT_DECIMAL) => abbrNumberFilter()(val, undefined, decimal),
    // @ts-expect-error FIXME: Type 'string | number' is not assignable to type 'string'.
    [MetricFormat.percent]: (val, decimal = DEFAULT_DECIMAL) => simplePercentageFilter()(val, decimal),
    [MetricFormat.percentSign]: (val, decimal = DEFAULT_DECIMAL) => percentageSignFilter()(val, decimal),
    [MetricFormat.time]: (val) => pureNumberFilter(val, TIME_FORMAT),
    numberAbbrWithPrefix: (val, prefix) => abbrNumberWithPrefixFilter()(val, prefix),
};

export const formatPercentSign = (val: number, decimal: number): string => percentageSignFilter()(val, decimal);
export const formatAbbrWithPrefix = (val: number, prefix: string): string => abbrNumberWithPrefixFilter()(val, prefix);
export const formatPP = (val: number): string =>
    `${simplePercentageFilter()(val, DEFAULT_DECIMAL)} ${PERCENTAGE_POINT}`;
